<script setup lang="ts">
import ApplicationBase from '@/components/Applications/ApplicationBase.vue'
import { useJoakimStore } from '@/stores/useJoakimStore'

// Steps (keep your names)
import Step2 from './Steps/Step2.vue'          // expects to run the bank check (see props below)
import Step3 from './Steps/Step3.vue'
import Undirritun from '../Shared/Undirritun.vue'
// import Step4 from './Steps/Step4.vue'
import BeginStep from './Steps/ApplicationBreytingSereignBegin.vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'

// Legacy used type 5 for this application
const APP_ID = 5
const UPDATE_KEY = 'sereignbreyting'


// ---- Bank check (reuse the joakim store endpoint) ----
const joakim = useJoakimStore()


// ---- Step configuration (in order) ----
const steps = [
    
  // 1
  { comp: BeginStep,       titleKey: '' },
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header' },

  // 2 — Pass the bank check function down to Step2
  { comp: Step2,       titleKey: 'umsokn_sereignbreyting_step2_header' },

  // 3
  { comp: Step3,       titleKey: 'umsokn_samantekt_header' },

  // 4 — Undirritun
  { comp: Undirritun,  titleKey: 'undirritun_umsokn_header1' },

  // 5 — Thank you / final
//   { comp: Step4,       titleKey: 'umsokn_sereignbreyting_header_step4' },
]
</script>

<template>
  <ApplicationBase :app-id="APP_ID" :update-key="UPDATE_KEY" :steps="steps" />
</template>
